import { LoadableAfterPaint } from '@confluence/loadable';

export const BlogPostsSSRExtensionHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlogPostsSSRExtensionHandler" */ '../src/BlogPostsSSRExtensionHandler.tsx'
			)
		).BlogPostsSSRExtensionHandler,
});
